import ClearLessonSelectionAction from '../../../../../lessons/lessonactions/lesson-multi-selection-actions/ClearLessonSelectionAction';
import TeacherCurriculumAssignLessonsAction from './TeacherCurriculumAssignLessonsAction';
import { useTeacherCurriculum } from '../../../context/TeacherCurriculumContextProvider';
import './LessonsMultiSelectionActions.scss';
import LessonsAddToGroupPlay from '../../../../../lessons/lessonactions/lesson-multi-selection-actions/LessonsAddToGroupPlay';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onClearClick: () => { },
  selectedLessonIds: [],
  isAssignAutoTag: true,
};

const LessonsMultiSelectionActions = (p) => {
  const { onClearClick, selectedLessonIds, isAssignAutoTag } = { ...defaultProps, ...filterUndefined(p) };
  const { teacherCurriculumDomain } = useTeacherCurriculum();
  const { lessonData } = teacherCurriculumDomain.domainData;
  const { lessons } = lessonData;

  return (
    <div className='teacher-curriculum-lessons-multi-selection-actions'>
      <LessonsAddToGroupPlay
        lessons={lessons}
        selectedLessonIds={selectedLessonIds}
      />
      <TeacherCurriculumAssignLessonsAction
        lessons={lessons}
        selectedLessonIds={selectedLessonIds}
        key='teacher-curriculum-lessons-assign-to-others'
        isAssignAutoTag={isAssignAutoTag}
      />
      <ClearLessonSelectionAction
        className='clear-selection'
        onClearClick={onClearClick}
        selectedLessonIds={selectedLessonIds}
      />
    </div>
  );
};

export default LessonsMultiSelectionActions;
